import {
  Autocomplete,
  Button,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import AddNewAccountDialog from "./AddNewAccount";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useSelector } from "react-redux";
import {
  selectUserData /* setIsLoading */,
} from "../../../../features/userSlice";
import { Box, Stack } from "@mui/system";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import AuctionInsights from "../AuctionInsights/AuctionInsights";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSearchParams } from "react-router-dom";

interface Props {
  rows: any;
  modifiedArray: any;
  selectedRows: any;
  setSelectedRows: any;
  advertisingAccounts: any[];
  selectedOptionSource: string[];
  setSelectedOptionSource: React.Dispatch<React.SetStateAction<string[]>>;
  selectedOptionAsset: string[];
  setSelectedOptionAsset: React.Dispatch<React.SetStateAction<string[]>>;
  selectedOptionTerritory: string[];
  setSelectedOptionTerritory: React.Dispatch<React.SetStateAction<string[]>>;
  selectedAccount: string;
  setSelectedAccount: any;
  selectedAsset: any;
  setSelectedAsset: any;
  selectedAdvertisementSource: any;
  setSelectedAdvertisementSource: any;
  selectedTerritory: any;
  setSelectedTerritory: any;
  siteNames: any;
  oauthTokenHeader: string;
  isRowTrue: any;
  rowId: any;
  isEditBtnEnabled: any;
  isCheckboxCheckedArray: any;
  setIsEditBtnEnabled: any;
  setReloadAfterToggleEdit: any;
  fetchAdAccountData: any;
  getTrafficSource: any;
  trafficSources: any;
  setTrafficSourceData: any;
  getAdAccountDetailsForEdit: Function;
  editDialogOpen: any;
  setEditDialogOpen: any;
  fetchSingleAdAccountData: Function;
  singleAdAccountData: any;
  setSingleAdAccountData: any;
  setRowId: any;
  rowIndexNumber: any;
  setrowIndexNumber: any;
  setIsCheckboxCheckedArray: any;
  postWebsiteToAcc: Function;
  setAccountUpdateStatus: any;
  accountUpdateStatus: any;
}

const CardFilters = ({
  modifiedArray,
  advertisingAccounts,
  siteNames,
  selectedAsset,
  setSelectedAsset,
  selectedAdvertisementSource,
  setSelectedAdvertisementSource,
  selectedTerritory,
  setSelectedTerritory,
  selectedAccount,
  setSelectedAccount,
  oauthTokenHeader,
  rowId,
  isCheckboxCheckedArray,
  setReloadAfterToggleEdit,
  setIsEditBtnEnabled,
  getTrafficSource,
  trafficSources,
  fetchAdAccountData,
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [auctionOpen, setAuctionOpen] = useState(false);
  const [searchTerritory, setSearchTerritory] = useState("");
  const [searchAsset, setSearchAsset] = useState("");
  const [searchAdSource, setSearchAdSource] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const userData = useSelector(selectUserData);
  const hasAddNewAccountPermission = CheckPermissions(
    userData?.data?.products?.paid_traffic,
    "advertising_accounts",
    "create_ads_account"
  );

  const hasUploadAuctionInsightsPermission = CheckPermissions(
    userData?.data?.products?.paid_traffic,
    "advertising_accounts",
    "upload_auction_insights_backend"
  );

  const clearFilters = () => {
    setSelectedAsset(null);
    setSelectedAdvertisementSource(null);
    setSelectedTerritory(null);
    setSelectedAccount("");
    setSearchAdSource("");
    setSearchAsset("");
    setSearchTerritory("");
  };

  const asset = advertisingAccounts.map((account) =>
    Object.keys(account.linked_assets).map((asset) => asset)
  );

  const websitePermissions =
    userData?.data?.website_permissions && userData?.data?.website_permissions;
  const mergedAssets = Array.from(new Set(asset.flat()));
  const excludedTrafficSources = [
    "direct",
    "direct_clickout",
    "manual_adjustment",
  ];

  const account = advertisingAccounts
    ?.filter(
      (item: any) => !excludedTrafficSources.includes(item?.traffic_source)
    )
    .map((item: any) => item?.account_name);

  const handleDialogOpen = (): void => {
    getTrafficSource();
    setReloadAfterToggleEdit(false);
    setDialogOpen(true);
  };

  const handleDialogClose = (): void => {
    setDialogOpen(false);
  };

  const handleAuctionOpen = (): void => {
    setAuctionOpen(true);
  };

  const handleAuctionClose = (): void => {
    setAuctionOpen(false);
  };

  const allFalse = isCheckboxCheckedArray.every(
    (element: any) => element === false
  );

  const [, /* stringArray */ setStringArray] = useState([]);

  useEffect(() => {
    if (rowId) {
      // Check if rowId is defined
      const addStringToArray = (rowId: string) => {
        setStringArray((prevArray: any) => {
          if (prevArray.includes(rowId)) {
            return prevArray.filter((str: string) => str !== rowId);
          } else {
            return [...prevArray, rowId];
          }
        });
      };
      addStringToArray(rowId);
    }
  }, [rowId, allFalse]);

  const filterConfig = [
    {
      key: "assets",
      label: "Select am Asset",
      searchTerm: searchAsset,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAsset(e.target.value),
      selectedOption: selectedAsset,
      filterName: "websites__site_name",
      data: modifiedArray,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedAsset(updatedSelection),
      count: selectedAsset?.length,
      colorSelected: selectedAsset?.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
      siteNames: siteNames,
    },
    {
      key: "Traffic Source",
      label: "Select a Source",
      searchTerm: searchAdSource,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdSource(e.target.value),
      selectedOption: selectedAdvertisementSource,
      filterName: "traffic_source",
      data: modifiedArray,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedAdvertisementSource(updatedSelection),
      count: selectedAdvertisementSource && selectedAdvertisementSource?.length,
      colorSelected:
        selectedAdvertisementSource !== null &&
        selectedAdvertisementSource?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: false,
      showSearch: true,
    },
    {
      key: "Territory",
      label: "Select One or More Territories",
      searchTerm: searchTerritory,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchTerritory(e.target.value),
      selectedOption: selectedTerritory,
      filterName: "territory",
      data: modifiedArray,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedTerritory(updatedSelection),
      count: selectedTerritory && selectedTerritory?.length,
      colorSelected:
        selectedTerritory !== null && selectedTerritory?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    setSelectedAccount(searchParams.get("search"));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Paper sx={{ borderRadius: "4px 0px" }}>
        <Box sx={{ padding: "8px 16px" }}>
          <Typography fontSize={24}>Advertising Account Management</Typography>
          <Typography fontSize={14} color="textSecondary" mb={2}>
            Create new or edit existing advertising accounts.{" "}
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Stack
              direction="row"
              spacing={2}
              display={"flex"}
              alignItems={"center"}
            >
              <Autocomplete
                data-tracker="179"
                options={account ? account : []}
                value={selectedAccount}
                onChange={(_, newValue) => {
                  setSelectedAccount(newValue);
                  setIsEditBtnEnabled(true); // Update state with selected account
                  setSearchParams((prevParams) => {
                    const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
                    if (newValue) {
                      updatedParams.search = newValue; // Set new value
                    } else {
                      delete updatedParams.search; // Remove from URL if cleared
                    }
                    updatedParams.page = "0";
                    return updatedParams;
                  });
                }}
                renderOption={(account, option: any, { selected }) => (
                  <Box
                    component="li"
                    {...account}
                    sx={{
                      backgroundColor: selected
                        ? "#F7EEF9 !important"
                        : "inherit",
                    }}
                  >
                    {option}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Account Name"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ marginLeft: "12px" }} />
                        </InputAdornment>
                      ),
                    }}
                    color="secondary"
                  />
                )}
                size="small"
                sx={{ width: "300px" }}
              />
              <Box data-tracker="179">
                <FilterComponent
                  filterConfig={filterConfig}
                  clearFilters={clearFilters}
                />
              </Box>
            </Stack>
            {/* Action Buttons */}
            <Stack
              direction="row"
              spacing={2}
              display={"flex"}
              alignItems={"center"}
            >
              {hasUploadAuctionInsightsPermission ? (
                <Button
                  data-tracker="183"
                  variant="outlined"
                  color="secondary"
                  onClick={handleAuctionOpen}
                >
                  <Stack direction="row" alignItems={"flex-start"} gap={1}>
                    Add Auction Insights{" "}
                    <FileUploadOutlinedIcon fontSize="small" />
                  </Stack>
                </Button>
              ) : (
                <Button variant="outlined" color="secondary" disabled>
                  <Stack direction="row" alignItems={"flex-start"} gap={1}>
                    Add Auction Insights{" "}
                    <FileUploadOutlinedIcon fontSize="small" />
                  </Stack>
                </Button>
              )}

              {hasAddNewAccountPermission ? (
                <Button
                  data-tracker="184"
                  aria-hidden="false"
                  variant="contained"
                  color="secondary"
                  onClick={handleDialogOpen}
                >
                  <Stack direction="row" alignItems={"flex-start"} gap={1}>
                    {" "}
                    ADD NEW ACCOUNT <AddIcon fontSize="small" />
                  </Stack>
                </Button>
              ) : (
                <Button disabled>
                  <Stack direction="row" alignItems={"flex-start"} gap={1}>
                    {" "}
                    ADD NEW ACCOUNT <AddIcon fontSize="small" />
                  </Stack>
                </Button>
              )}
              <AddNewAccountDialog
                siteNames={siteNames}
                websitePermissions={websitePermissions}
                setReloadAfterToggleEdit={setReloadAfterToggleEdit}
                open={dialogOpen}
                setDialogOpen={setDialogOpen}
                handleClose={handleDialogClose}
                trafficSources={trafficSources}
                oauthTokenHeader={oauthTokenHeader}
                mergedAssets={mergedAssets}
                fetchAdAccountData={fetchAdAccountData}
              />
              <AuctionInsights
                open={auctionOpen}
                handleClose={handleAuctionClose}
                advertisingAccounts={advertisingAccounts}
                handleOpen={handleAuctionOpen}
              />
            </Stack>
          </Stack>
        </Box>
      </Paper>
    </>
  );
};
export default CardFilters;
